import script from "./FooterArea.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterArea.vue?vue&type=script&setup=true&lang=js"

import "./FooterArea.vue?vue&type=style&index=0&id=379e8035&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-379e8035"]])

export default __exports__